export default __webpack_public_path__ + "d630ed0cb3c5d7a62f4c68bdf68643cf.svg";